import { renderTemplate } from '../../Utils/templateUtils';

const defaultParams = {
    page: 0,
    size: 20
};

export default class ListingsAPI {

    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(ListingsAPI.SearchListingsPath);
        this.DashAPI.ApiPathMgr.add(ListingsAPI.GetListingPath);
        this.DashAPI.ApiPathMgr.add(ListingsAPI.GetListingFeaturesPath);
        this.DashAPI.ApiPathMgr.add(ListingsAPI.GetListingImagesPath);
        this.DashAPI.ApiPathMgr.add(ListingsAPI.GetListingOpenHousesPath);
    }

    search(params) {
        const normParams = Object.assign({}, defaultParams, params);
        return this.DashAPI.CORE.get(ListingsAPI.SearchListingsPath, normParams);
    }

    getById(listingId) {
        var urlPath = renderTemplate(ListingsAPI.GetListingPath, { listingId: listingId });
        return this.DashAPI.CORE.get(urlPath);
    }

    getFeaturesById(listingId) {
        var urlPath = renderTemplate(ListingsAPI.GetListingFeaturesPath, { listingId: listingId });
        return this.DashAPI.CORE.get(urlPath);
    }

    getImagesById(listingId) {
        var urlPath = renderTemplate(ListingsAPI.GetListingImagesPath, { listingId: listingId });
        return this.DashAPI.CORE.get(urlPath);
    }

    getOpenHousesById(listingId) {
        var urlPath = renderTemplate(ListingsAPI.GetListingOpenHousesPath, { listingId: listingId });
        return this.DashAPI.CORE.get(urlPath);
    }
}

ListingsAPI.SearchListingsPath = '/api/listings/search';
ListingsAPI.GetListingPath = '/api/listings/{listingId}';
ListingsAPI.GetListingFeaturesPath = '/api/listings/{listingId}/features';
ListingsAPI.GetListingImagesPath = '/api/listings/{listingId}/images';
ListingsAPI.GetListingOpenHousesPath = '/api/listings/{listingId}/openhouses';

// ListingsAPI.GetMarketingListingsPath = '/api/marketing/projects';
// ListingsAPI.GetListingsPath = '/api/listings/';
// ListingsAPI.SearchListingsPath = '/api/listings/search';



// WEBPACK FOOTER //
// ./src/DashApi/listings/ListingsApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/listings/ListingsApi.js